import Button, { ButtonProps } from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

import { SkeletonWrapper } from "@/components/SkeletonWrapper";

type Props = ButtonProps & {
	skeleton?: boolean;
	title?: string;
};

export function SaveButton({ skeleton = false, disabled, title, ...rest }: Props) {
	return skeleton ? (
		<SkeletonWrapper height={25} width={80} />
	) : (
		<Button className="hover-elevate-up py-1" disabled={disabled} {...rest}>
			{disabled ? (
				<Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
			) : (
				title || "Salvar"
			)}
		</Button>
	);
}
